//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useContext, useMemo } from 'react';
import { forwardRef } from "react";

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  TextField,
} from '@mui/material';

// === CONSTANTS ===
import { SUCCESS_CODE } from 'constants/general';

// === COMPONENTS ===
import { ContextDoctype } from 'pages/FileViewer/components/DocumentReview/components/DoctypeContext/DoctypeContext';

// === API ===

//#endregion

export default forwardRef( Doctype );

//-----------------------------------------------------------------
function Doctype( props, ref ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { content, handleChange, handleFocus } = props;

  const theme = useTheme();

  const {
    documents,
  } = useContext( ContextDoctype );

  const document = useMemo( getDocument, [documents, content] );

  //#endregion
  
  //#region [STYLES]

  const _styles = {
    select_doc: {
      width: '100%',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
  }

  const SELECT_DOC = {
    sx          : _styles.select_doc,
    id          : 'doc-select',
    options     : documents   ,
    value       : document    ,
    size        : 'small',
    freeSolo    : true, 
    onChange    : onChange,
    onFocus     : onFocus,
    onKeyDown   : onKeyDown,
    renderInput : (params) => <TextField {...params} 
          inputRef={ref}
          tabIndex={0}
          variant='standard' // Use a variant with no FormControl border
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
          }}
          sx={{
            paddingTop: '4px',
            paddingLeft: '12px',
            '& .MuiFormControl-root': {
              display: 'unset',
            },
          }}/>,
    getOptionLabel : (option) => option.label,
    disableClearable : true,
  };

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    if( handleChange ) handleChange( value?.numcode )
  }

  //-----------------------------------------------------------------
  function onFocus( event ) {
    //-----------------------------------------------------------------
    if( handleFocus ) handleFocus( event )
  }

  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    if( event.key === 'PageUp' ) {
      event.defaultMuiPrevented = true;
    }
    else if( event.key === 'PageDown' ) {
      event.defaultMuiPrevented = true;
    }
  }

  //#endregion

  //#region

  //-----------------------------------------------------------------
  function getDocument() {
    //-----------------------------------------------------------------
    let num = content;
    if( !content?.startsWith('D') ) num = 'D' + content;
    return documents.find( x=> x.numcode === num );
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Autocomplete { ...SELECT_DOC } />
    );
  } 

  //#endregion

  return display();
}